import { LANGUAGES, TUrl } from "./types";

export const DEFAULT_BASE_URL: TUrl = "https://api.beamimpact.com";

export const DEFAULT_LOG_URL = "https://production.beamimpactlogs.com";

export const SUPPORTED_LANGUAGES: Record<string, LANGUAGES> = {
  en: "en",
  fr: "fr",
  de: "de",
  es: "es",
  it: "it",
  pl: "pl",
};

export const WIDGET_NAMES = {
  select_nonprofit: "select-nonprofit",
  redeem_transaction: "redeem-transaction",
  impact_overview: "impact-overview",
  community_impact: "community-impact",
  cumulative_impact: "cumulative-impact",
  product_details_page: "product-details-page",
  subscription_management: "subscription-management",
  subscription_impact: "subscription-impact",
  select_subscription_nonprofit: "select-subscription-nonprofit",
  social_share: "social-share",
} as const;

export const HELPER_NAMES = {
  cart_update: "cart_update",
};
